import { useState, useEffect } from "react";

export default function useScreenWidth() {
  // This hook returns the current width of the screen, which is updated live
  // as the user resizes the window.

  // We initialize the state with the current width of the screen.
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 576);
  const [isLargerDevice, setIsLargerDevice] = useState(false);

  // We use the useEffect hook to set up an event listener on the window
  // that will call our "handleResize" function whenever the window is resized.
  useEffect(() => {
    // The handleResize function updates the state with the new width of the
    // screen.
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenWidth(width);
      setIsMobileView(width < 576);
      setIsLargerDevice(width >= 768);
    };

    // We add the event listener to the window.
    window.addEventListener("resize", handleResize);

    // We call the event listener once, to set the state initially.
    handleResize();

    // We also return a function that will be called when the component is
    // unmounted. This function will remove the event listener, so that we
    // don't get any memory leaks.
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Finally, we return the current width of the screen, and two booleans
  // indicating whether the screen is a mobile view or a larger device.
  return { screenWidth, isMobileView, isLargerDevice };
}
